import { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  IconButton,
  TextField,
  Box,
  Breadcrumbs,
  Autocomplete, InputAdornment,
  Link
} from "@mui/material";

import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrn from "../../components/grid/ViewDataGridGrn";
import { supplierData } from "../../components/grid/GridDataGrn";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import { externalgetApi } from "../../services/externalApis";
import { SUPPLIER_API_02 } from "../../api/ApiModel";
import {
  CON_STATUS_Saved,
  CON_STATUS_PENDING,
  CON_STATUS_Submited,
  CON_STATUS_APPROVED,
  CON_STATUS_REJECTED,
  CON_STATUS_CANCEL_modifiy,
  CON_STATUS_RETURN,
} from "../../utils/sys/Constants";

const top100Films = [
  { title: "The Shawshank Redemption", year: 1994 },
  { title: "The Godfather", year: 1972 },
  { title: "The Godfather: Part II", year: 1974 },
];

// Define your status options
const statusOptions = [
  { label: "Saved", value: CON_STATUS_Saved },
  { label: "Pending", value: CON_STATUS_PENDING },
  { label: "Submitted", value: CON_STATUS_Submited },
  { label: "Approved", value: CON_STATUS_APPROVED },
  { label: "Rejected", value: CON_STATUS_REJECTED },
  { label: "Cancel/Modify", value: CON_STATUS_CANCEL_modifiy },
  { label: "Returned", value: CON_STATUS_RETURN },
];

function Supplier() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const [status, setStatus] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState({});
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const [isLoading, setIsLoading] = useState(false);

  const SYS_USER = useSelector((state) => state.user) || {};
  const { LOCCODE, STAFFMAPLOCODE, COMPCODE } = SYS_USER.USER_PARAM || {};

  useEffect(() => {
    setPageData({
      title: "Supplier Management",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  
  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.suprefcode === id.suprefcode);
      if (selectedItem) {
        navigate(`/CreateSupplier`, { state: { selectedItem, actionText } });
      }
    }
  };


  
  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (suprefcode) => handleItemClick(suprefcode, "Edit"),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SUPPLIER_API_02, "get", {
          COMPCODE,
          // LOCCODE: STAFFMAPLOCODE,
          // STSCODE: "" || status,
          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        setFilteredRows(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [status]);

  // Handle search input change
  const handleSearchChange = (event, value) => {
    setSearchQuery(value); // Update search query state

    // Filter rows based on search query
    const filtered = data?.filter((row) =>
      row.suppliername.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRows(filtered || []);
  };

  const addToView = () => {
    navigate("/CreateSupplier");
  };

  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>

          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
            Supplier Management
          </Link>
        </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {supplierData.name}
              </Typography>
            </Grid>

            <Grid item size={{ xs: 12, sm: 2, md: 2, lg: 2, xl: 2 }}>
              {/* <Autocomplete
                options={statusOptions}
                getOptionLabel={(option) => option.label}
                value={
                  statusOptions.find((opt) => opt.value === status) ||
                  statusOptions[0]
                }
                onChange={(_, newValue) =>
                  setStatus(newValue ? newValue.value : "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status"
                    variant="outlined"
                    size="small"
                  />
                )}
                fullWidth
                disableClearable
              /> */}
            </Grid>

            <Grid
              item
              size={{ xs: 12, sm: 4, md: 6, lg: 4, xl: 4 }}
              sx={styles.appbar_grid_search}
            >
              <Autocomplete
                freeSolo
                id="sample-search"
                fullWidth
                disableClearable
                value={searchQuery}
                onInputChange={handleSearchChange} // Handle search input change
                sx={styles.ipt_appbar_search_auto}
                options={data?.map((row) => row.suppliername) || []} // Provide options for autocomplete
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search by..."
                    size="small"
                    sx={styles.ipt_appbar_search}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton sx={styles.btn_appbar_search_icon}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />

              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={addToView}
              >
                Create
              </Button>
            </Grid>
          </Grid>
        </AppBar>

        <Box sx={styles.view_page_container}>
          <ViewDataGridGrn
            columns={supplierData.columns}
            rows={filteredRows.map((row) => ({
              ...row,
              id: row.suprefcode || Math.random(),
            }))}
            getRowId={(row) => row.id} // Use the id property for unique identification
            menuItems={menuItems}
            isLoading={isLoading}
            tabletitle={supplierData.name}
            gridid="suprefcode"
            sx={styles.view_data_grid_page}
          />
        </Box>
      </Box>
    </>
  );
}
export default Supplier;
